<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px;width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>Costing Comparision DashBoard</h1>
            </div>

            <!-- <div style="margin-bottom: 20px;">
                <a routerLink="/errordashboard" class="link-card">Back</a>
            </div> -->

            <div class="card">
                <p-table [value]="costingCheckerData" [tableStyle]="{'min-width': '60rem'}" [paginator]="true"
                    [rows]="10" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>NDA Number</th>
                            <th>Brand Name</th>
                            <th>Active Ingredient</th>
                            <th>Route Of Administration</th>
                            <th>Dosage Forms</th>
                            <th>Cumulative Investment in Cost DB</th>
                            <th>Cumulative Investment in Main DB</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData['NDA number'] }}</td>
                            <td>{{ rowData['Brand Name'] }}</td>
                            <td>{{ rowData['Active Ingredient'] }}</td>
                            <td>{{ rowData['Route of Administration'] }}</td>
                            <td>{{ rowData['Dosage forms'] }}</td>
                            <td>{{ rowData['cumulative_investment in cost DB'] | currency}}</td>
                            <td>{{ rowData['cumulative_investment in main DB'] | currency}}</td>

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft">
                        <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
                    </ng-template>
                    <ng-template pTemplate="paginatorright">
                        <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-container>
</div>